import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiHelper } from "../utils/apiHelper";
import { toast } from "react-toastify";

// Async Thunk for Updating User Information
export const updateUserInfo = createAsyncThunk(
    "user/updateUserInfo",
    async (updatedInfo, { rejectWithValue }) => {
        try {
            console.log(updatedInfo)
            const response = await ApiHelper.post("/account/update", updatedInfo);
            console.log("Gelen Yanıt:", response.data); // API'den gelen yanıtı kontrol edin

            if (response.data.code === "00000") {
                toast.success("Bilgiler başarıyla güncellendi.");
                return updatedInfo; // Güncellenen bilgileri döner
            } else if (response.data.code === "80001") {
                toast.error("Hesabınız e-devlet onaylı olduğu için bilgiler güncellenemedi.");
            } else {
                throw new Error("Update failed");
            }
        } catch (error) {
            return rejectWithValue(error.message || "An error occurred");
        }
    }
);




export const changePassword = createAsyncThunk(
    "user/changePassword",
    async (passwords, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.post("/account/change-password", passwords);
            if (response.data.code === "00000") {
                return response.data;
            } else {
                throw new Error(response.data.message || "Şifre değiştirme başarısız.");
            }
        } catch (error) {
            return rejectWithValue(error.message || "Bir hata oluştu.");
        }
    }
);

export const fetchUserActivityLogs = createAsyncThunk(
    "user/fetchUserActivityLogs",
    async (_, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.get("/account/user-activity");
            console.log(response)
            if (response.data.code === "00000") {
                return response.data.userActivity; // Kullanıcı aktivitelerini döner

            } else {
                throw new Error(response.data.message || "Aktiviteler alınamadı.");
            }
        } catch (error) {
            return rejectWithValue(error.message || "Bir hata oluştu.");
        }
    }
);

export const submitEntrepreneurForm = createAsyncThunk(
    "entrepreneur/submitForm",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.post("/account/entrepreneur-form", formData);
            if (response.status === 200 && response.data.code === "00000") {
                return response.data;
            } else {
                throw new Error(response.data.message || "Form gönderimi başarısız.");
            }
        } catch (error) {
            return rejectWithValue(error.message || "Bir hata oluştu.");
        }
    }
);

export const updateEntrepreneurForm = createAsyncThunk(
    "entrepreneur/updateForm",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.put("/account/entrepreneur-form", formData);
            if (response.status === 200 && response.data.code === "00000") {
                return response.data;
            } else {
                throw new Error(response.data.message || "Form güncellemesi başarısız.");
            }
        } catch (error) {
            return rejectWithValue(error.message || "Bir hata oluştu.");
        }
    }
);

// Async Thunk for Fetching Entrepreneur Form
export const fetchEntrepreneurForm = createAsyncThunk(
    "user/fetchEntrepreneurForm",
    async (_, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.get("/account/entrepreneur-form");
            if (response.data.code === "00000") {
                return response.data.entrepreneurInfo;
            } else {
                console.log(response.data)
            }
        } catch (error) {
            return rejectWithValue(error.message || "Bir hata oluştu.");
        }
    }
);

export const fetchInvestorForm = createAsyncThunk(
    "user/fetchInvestorForm",
    async (_, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.get("/account/investor-form");
            if (response.data.code === "00000") {
                return response.data.investorInfo;
            } /* else {
                throw new Error(response.data.message || "Yatırımcı bilgileri alınamadı.");
            } */
        } catch (error) {
            return rejectWithValue(error.message || "Bir hata oluştu.");
        }
    }
);

export const submitInvestorForm = createAsyncThunk(
    "investor/submitForm",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.post("/account/investor-form", formData);
            if (response.status === 200 && response.data.code === "00000") {
                return response.data;
            } else {
                throw new Error(response.data.message || "Form gönderimi başarısız.");
            }
        } catch (error) {
            return rejectWithValue(error.message || "Bir hata oluştu.");
        }
    }
);

export const updateInvestorForm = createAsyncThunk(
    "investor/updateForm",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.put("/account/investor-form", formData);
            if (response.status === 200 && response.data.code === "00000") {
                return response.data;
            } else {
                throw new Error(response.data.message || "Form güncellemesi başarısız.");
            }
        } catch (error) {
            return rejectWithValue(error.message || "Bir hata oluştu.");
        }
    }
);

export const deleteAccount = createAsyncThunk(
    'user/deleteAccount',
    async (_, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.post('/account/delete-account');

            if (response.status === 200 && response.data.code === "00000") {
                return response.data;
            } else {
                throw new Error(response.data.message || "Hesap silme başarısız.");
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Slice
const userSlice = createSlice({
    name: "user",
    initialState: {
        userInfo: null,
        entrepreneurInfo: null,
        investorInfo: null,
        loading: false,
        error: null,
        logs: [],
    },
    reducers: {
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
         resetState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateUserInfo.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateUserInfo.fulfilled, (state, action) => {
                state.loading = false;
                state.userInfo = { ...state.userInfo, ...action.payload };
            })
            .addCase(updateUserInfo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(changePassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(changePassword.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(changePassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchUserActivityLogs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserActivityLogs.fulfilled, (state, action) => {
                state.loading = false;
                state.logs = action.payload;
            })
            .addCase(fetchUserActivityLogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(submitEntrepreneurForm.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(submitEntrepreneurForm.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
                state.error = null;
            })
            .addCase(submitEntrepreneurForm.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload;
            })
            .addCase(fetchEntrepreneurForm.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchEntrepreneurForm.fulfilled, (state, action) => {
                state.loading = false;
                state.entrepreneurInfo = action.payload;
            })
            .addCase(fetchEntrepreneurForm.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateEntrepreneurForm.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(updateEntrepreneurForm.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
                state.error = null;
            })
            .addCase(updateEntrepreneurForm.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload;
            })
            .addCase(fetchInvestorForm.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchInvestorForm.fulfilled, (state, action) => {
                state.loading = false;
                state.investorInfo = action.payload;
            })
            .addCase(fetchInvestorForm.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(submitInvestorForm.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(submitInvestorForm.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
                state.error = null;
            })
            .addCase(submitInvestorForm.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload;
            })
            .addCase(updateInvestorForm.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(updateInvestorForm.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
                state.error = null;
            })
            .addCase(updateInvestorForm.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload;
            })
            .addCase(deleteAccount.fulfilled, (state) => {
                state.logs = [];
                state.loading = false;
                state.error = null;
            })
            .addCase(deleteAccount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setUserInfo, resetState } = userSlice.actions;
export default userSlice.reducer;
